import { useTranslation } from 'react-i18next'
import type { Hypothesis, HypothesisItem } from '@/types/hypothesis'
import { Section } from './Section'

export function StatementSection({ hypothesis }: { hypothesis: Hypothesis }) {
  const { t } = useTranslation()
  return (
    <Section title={t('search.detail.statement.title')} hint={t('search.detail.statement.hint')}>
      <p className="break-words text-sm leading-relaxed text-foreground">
        {hypothesis.caseDescription}
      </p>
      {hypothesis.items.length > 0 && (
        <ul className="mt-4 flex flex-col gap-2">
          {hypothesis.items.map(item => (
            <ItemRow key={item.id} item={item} />
          ))}
        </ul>
      )}
    </Section>
  )
}

function ItemRow({ item }: { item: HypothesisItem }) {
  return (
    <li className="flex items-start gap-2 rounded-lg border border-border bg-muted/20 px-3 py-2">
      <span className="shrink-0 rounded border border-primary/40 bg-primary/10 px-1.5 py-0.5 text-3xs font-bold uppercase text-primary">
        {item.kind === 'question' ? 'Q' : 'C'}
      </span>
      <span className="min-w-0 break-words text-sm text-foreground">{item.text}</span>
    </li>
  )
}
